import React, { useState } from 'react';
import { Helmet } from 'react-helmet'; // ▼▼▼ ADDED ▼▼▼
import { useLocation } from 'react-router-dom'; // ▼▼▼ ADDED ▼▼▼
import './Garden.css';

const PrimeLocationEn = () => {
    const [lightboxImage, setLightboxImage] = useState(null);
    const { pathname } = useLocation(); // ▼▼▼ ADDED ▼▼▼

    return (
        // ▼▼▼ Wrapped with Fragment <> ▼▼▼
        <>
            {/* ▼▼▼ ADDED THIS ENTIRE HELMET BLOCK ▼▼▼ */}
            <Helmet>
                <title>Prime Location for Sightseeing | Five Features | Kanazawa Stay Akebono</title>
                <meta name="description" content="Kanazawa Stay Akebono is perfectly located for sightseeing, just an 8-minute walk from Kenrokuen Garden and the 21st Century Museum. Explore Kanazawa's top attractions with ease." />
                <link rel="canonical" href={`https://kanazawa-stay-akebono.com${pathname}`} />
                <meta property="og:title" content="A Prime Location in Kanazawa | Kanazawa Stay Akebono" />
                <meta property="og:description" content="Perfectly located for sightseeing, just an 8-minute walk from Kenrokuen Garden and the 21st Century Museum. Explore Kanazawa's top attractions with ease." />
                <meta property="og:url" content={`https://kanazawa-stay-akebono.com${pathname}`} />
                <meta property="og:image" content="https://kanazawa-stay-akebono.com/images/access1.jpg" />
            </Helmet>
            {/* ▲▲▲ ADDITION ENDS HERE ▲▲▲ */}

            <div className="akebono-garden-page">

                {/* HERO Section */}
                <section className="akebono-garden-hero" style={{ backgroundImage: "url('/images/access1.jpg')" }}>
                    <div className="akebono-garden-hero-overlay">
                        <h1>A Prime Location in Kanazawa</h1>
                    </div>
                </section>

                {/* Nearby Attractions */}
                <section className="akebono-garden-feature">
                    <h2>Explore the Neighborhood</h2>

                    <div className="garden-card">
                        <img src="/images/spot-kenrokuen.jpg" alt="Kenrokuen" onClick={() => setLightboxImage('/images/spot-kenrokuen.jpg')} />
                        <div>
                            <h3>Kenrokuen Garden (8 min walk)</h3>
                            <p>One of Japan's Three Great Gardens. Enjoy the changing seasonal beauty—especially the iconic yukitsuri in winter.</p>
                        </div>
                    </div>

                    <div className="garden-card">
                        <img src="/images/spot-21museum.jpg" alt="21st Century Museum" onClick={() => setLightboxImage('/images/spot-21museum.jpg')} />
                        <div>
                            <h3>21st Century Museum of Contemporary Art (8 min walk)</h3>
                            <p>Famed for its modern art exhibitions. Don't miss Leandro Erlich's "Swimming Pool" installation.</p>
                        </div>
                    </div>

                    <div className="garden-card">
                        <img src="/images/spot-nishichaya.jpg" alt="Nishi Chaya District" onClick={() => setLightboxImage('/images/spot-nishichaya.jpg')} />
                        <div>
                            <h3>Nishi Chaya District (20 min walk)</h3>
                            <p>One of Kanazawa's three historic geisha districts. Discover the elegance of Kanazawa's entertainment culture.</p>
                        </div>
                    </div>

                    <div className="garden-card">
                        <img src="/images/spot-kanazawacastle.jpg" alt="Kanazawa Castle Park" onClick={() => setLightboxImage('/images/spot-kanazawacastle.jpg')} />
                        <div>
                            <h3>Kanazawa Castle Park (20 min walk)</h3>
                            <p>Adjacent to Kenrokuen. Enjoy a peaceful stroll through this beautifully maintained historic site.</p>
                        </div>
                    </div>

                    <div className="garden-card">
                        <img src="/images/spot-korinbo.jpg" alt="Korinbo" onClick={() => setLightboxImage('/images/spot-korinbo.jpg')} />
                        <div>
                            <h3>Korinbo District (20 min walk)</h3>
                            <p>Kanazawa’s main shopping area filled with department stores, fashion buildings, and hotels.</p>
                        </div>
                    </div>

                    <div className="garden-card">
                        <img src="/images/spot-katamachi.jpg" alt="Katamachi" onClick={() => setLightboxImage('/images/spot-katamachi.jpg')} />
                        <div>
                            <h3>Katamachi District (15 min walk)</h3>
                            <p>Kanazawa's bustling nightlife area with a wide variety of restaurants and shops, including traditional craft stores.</p>
                        </div>
                    </div>
                </section>

                {/* Lightbox */}
                {lightboxImage && (
                    <div className="lightbox" onClick={() => setLightboxImage(null)}>
                        <span className="lightbox-close">&times;</span>
                        <img src={lightboxImage} alt="Enlarged view" className="lightbox-content" />
                    </div>
                )}
            </div>
        </> // ▲▲▲ Wrapped with Fragment <> ▲▲▲
    );
};

export default PrimeLocationEn;